// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isOpenAiLiquidAssistantWithDiffsResult = objectOf({
  error: boolean,
  error_message: string,
  search: string,
  replace: string,
  response: string,
});
